module.exports = {
  borderRadius: {
    none: '0px',
    sm: '4px',
    DEFAULT: '8px',
    md: '8px',
    lg: '16px',
    full: '9999px',
  },
  boxShadow: {
    none: 'none',
    sm: '0 1px 3px 0 rgba(0, 0, 0, 0.06), 0 1px 1px 0 rgba(0, 0, 0, 0.04)',
    md: '0 3px 10px 0 rgba(0, 0, 0, 0.06), 0 1px 2px 0 rgba(0, 0, 0, 0.04)',
    lg: '0 5px 15px 0 rgba(0, 0, 0, 0.06), 0 1px 2px 0 rgba(0, 0, 0, 0.04)',
    xl: '0 10px 25px 0 rgba(0, 0, 0, 0.08), 0 1px 3px 0 rgba(0, 0, 0, 0.04)',
    '2xl': '0 15px 35px 0 rgba(0, 0, 0, 0.1), 0 2px 6px 0 rgba(0, 0, 0, 0.04)', // prettier-ignore
    '3xl': '0 20px 50px 0 rgba(0, 0, 0, 0.12), 0 4px 9px 0 rgba(0, 0, 0, 0.04)', // prettier-ignore
  },
  colors: {
    /** Functional colors */
    transparent: 'transparent',
    current: 'currentColor',
    inherit: 'inherit',

    // Neutrals
    n0: '#ffffff',
    n25: '#fafbfc',
    n50: '#f5f6f7',
    n75: '#f2f3f5',
    n100: '#edeef0',
    n150: '#e1e2e6',
    n200: '#c8cacf',
    n300: '#b8babf',
    n400: '#999b9e',
    n500: '#747578',
    n600: '#525254',
    n700: '#434445',
    n800: '#323233',
    n900: '#222222',
    n1000: '#000000',

    // Accents
    a1: '#fb6132',
    a2: '#ea2e6d',
    a3: '#a22bb6',
    a4: '#6438bc',
    a5: '#2470ff',
    a6: '#2b9af3',
    a7: '#00bbd4',
    a8: '#0293b0',
    a9: '#8fc559',
    a10: '#ffc108',

    // Blue
    b100: '#edefff',

    // Green
    g50: '#d4f2e2',
    g100: '#67e6a0',
    g200: '#54d68e',
    g300: '#42c97f',
    g700: '#227748',

    // Yellow
    y100: '#ffebc7',
    y400: '#f7bf34',
    y500: '#ffb13d',
    y700: '#806000',

    // Red
    r100: '#fee5ec',
    r500: '#f90143',
    r700: '#c31443',

    // Teal
    t400: '#3ed6c9',

    // Purple
    p500: '#955aed',

    // Brands
    brand: {
      apple: '#212121',
      facebook: '#1877f2',
      instagram: '#d93275',
      outlook: '#0078d6',
      subsplash: '#4f63ff',
      'subsplash-lite': '#cadefb',
      twitter: '#3bb0db',
      yahoo: '#6001d2',
      youtube: '#ff0000',
    },
  },
  fontFamily: {
    sans: [
      'Proxima-Nova',
      'helvetica neue',
      'helvetica',
      'arial',
      'sans-serif',
    ],
  },
  fontSize: {
    '2xs': '8px',
    xs: '12px',
    sm: '14px',
    base: '16px',
    lg: '18px',
    xl: '20px',
    '2xl': '24px',
    '3xl': '28px',
    '4xl': '36px',
  },
  screens: {
    xs: '420px',
    sm: '640px',
    md: '768px',
    lg: '1024px',
    xl: '1280px',
    '2xl': '1536px',
  },
  spacing: {
    // 0 and 1 are not in the design styleguide, but we still have use for
    // them as utility spaces in the code.
    0: '0px',
    1: '1px',
    '2xs': '2px',
    xs: '4px',
    sm: '8px',
    md: '12px',
    lg: '18px',
    xl: '24px',
    '2xl': '36px',
    '3xl': '48px',
    '4xl': '72px',
    '5xl': '96px',
  },

  // Extended Properties
  animation: {
    'scale-fade-in': 'scale-fade-in 225ms',
    'scale-out': 'scale-out 225ms both',
  },
  keyframes: {
    'scale-fade-in': {
      '0%': {
        opacity: '0',
        transform: 'scale(0.95)',
      },
      '100%': {
        opacity: '1',
        transform: 'scale(1)',
      },
    },
    'scale-out': {
      '0%': {
        transform: 'scale(1)',
        visibility: 'visible',
      },
      '100%': {
        transform: 'scale(0.95)',
        visibility: 'hidden',
      },
    },
  },
  lineHeight: {
    none: '1',
    '2xs': '10px',
    xs: '14px',
    sm: '17px',
    md: '20px',
    lg: '22px',
    xl: '24px',
    '2xl': '29px',
    '3xl': '34px',
    '4xl': '36px',
  },
  opacity: {
    2: '0.02',
    3: '0.03',
    4: '0.04',
    6: '0.06',
    8: '0.08',
    14: '0.14',
    15: '0.15',
  },
  transitionDuration: {
    '2xs': '50ms',
    xs: '75ms',
    sm: '125ms',
    md: '225ms',
    lg: '325ms',
    xl: '525ms',
  },
  transitionTimingFunction: {
    ease: 'cubic-bezier(0.42, 0, 0.58, 1)',
    'ease-in-out': 'cubic-bezier(0.645, 0.045, 0.355, 1)',
    'ease-overshot': 'cubic-bezier(0.39, 0.335, 0.305, 1.525)',
  },
};
